import * as yup from 'yup'

export class VehicleCheckInVehicleDetailsDto {
  vehicleCheckInOdometerReadingMileage?: number = undefined
  vehicleCheckInOdometerReadingUnitOfMeasurement?: string = undefined
  vehicleCheckInOdometerReadingKm?: number = undefined
  vehicleCheckInOdometerReadingMi?: number = undefined
  convertCluster?: boolean = undefined
  programCluster?: boolean = undefined
  vehicleCheckInBondNumber?: string = undefined
  vehicleCheckInMFGBuildDateMonth?: number = undefined
  vehicleCheckInMFGBuildDateYear?: number = undefined
  vehicleCheckInParkingSpace?: string = undefined
  vehicleCheckInWeightGVWR?: number = undefined
  vehicleCheckInWeightGVWRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGVWRKg?: number = undefined
  vehicleCheckInWeightGVWRLbs?: number = undefined
  vehicleCheckInCurbWeight?: number = undefined
  vehicleCheckInWeightGAWRFR?: number = undefined
  vehicleCheckInWeightGAWRFRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGAWRRR?: number = undefined
  vehicleCheckInWeightGAWRRRUnitOfMeasurement?: string = undefined
  vehicleCheckInFrontTires?: string = undefined
  vehicleCheckInFrontRims?: string = undefined
  vehicleCheckInFrontTiresPressure?: number = undefined
  vehicleCheckInFrontTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInRearTires?: string = undefined
  vehicleCheckInRearRims?: string = undefined
  vehicleCheckInRearTiresPressure?: number = undefined
  vehicleCheckInRearTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInNumberOfRearTires?: number = undefined
  importerNotes?: string = undefined
  isCheckedIn?: boolean = undefined
}

export const vehicleCheckInVehicleDetailsValidationSchema = yup.object<VehicleCheckInVehicleDetailsDto>({
  vehicleCheckInOdometerReadingMileage: yup
    .number()
    .min(0.0, 'Odometer Reading cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Odometer Reading cannot be more than 999,999,999,999,999.99.')
    .required('Odometer Reading is required.'),
  vehicleCheckInOdometerReadingUnitOfMeasurement: yup.string().oneOf(['Miles', 'Kilometers']).required('This field is required.'),
  vehicleCheckInMFGBuildDateMonth: yup
    .number()
    .min(1, 'MFG Build Date (Month) must be between 1 and 12.')
    .max(12, 'MFG Build Date (Month) must be between 1 and 12.')
    .required('MFG Buld Date (Month) is required.'),
  vehicleCheckInMFGBuildDateYear: yup
    .number()
    .min(1000, 'MFG Buld Date (Year) cannot be less than 1000.')
    .max(3000, 'MFG Buld Date (Year) cannot be more than 3000.')
    .required('MFG Buld Date (Year) is required.'),
  vehicleCheckInWeightGVWR: yup
    .number()
    .min(0.0, 'Weight GVWR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GVWR cannot be more than 999,999,999,999,999.99.')
    .nullable()
    .required('Weight GVWR is required.'),
  vehicleCheckInWeightGAWRFR: yup
    .number()
    .min(0.0, 'Weight GAWR FR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GAWR FR cannot be more than 999,999,999,999,999.99.')
    .nullable()
    .required('Weight GAWR FR is required.'),
  vehicleCheckInWeightGAWRFRUnitOfMeasurement: yup.string().required('Weight GAWR FR Unit Of Measurement is required.'),
  vehicleCheckInWeightGAWRRR: yup
    .number()
    .min(0.0, 'Weight GAWR RR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GAWR RR cannot be more than 999,999,999,999,999.99.')
    .nullable()
    .required('Weight GAWR RR is required.'),
  vehicleCheckInWeightGAWRRRUnitOfMeasurement: yup.string().required('Weight GAWR RR Unit Of Measurement is required.'),
  vehicleCheckInFrontTires: yup.string().max(200, 'Front Tires cannot be more than 200 characters.').nullable().required('Front Tires are required.'),
  vehicleCheckInFrontRims: yup.string().max(200, 'Front Rims cannot be more than 200 characters.').nullable().required('Front Rims are required.'),
  vehicleCheckInFrontTiresPressure: yup
    .number()
    .min(0.0, 'Front Tire Pressure cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Front Tire Pressure cannot be more than 999,999,999,999,999.99.')
    .nullable()
    .required('Front Tire Pressure is required.'),
  vehicleCheckInRearTires: yup.string().max(200, 'Rear Tires cannot be more than 200 characters.').nullable().required('Rear Tires are required.'),
  vehicleCheckInRearRims: yup.string().max(200, 'Rear Rims cannot be more than 200 characters.').nullable().required('Rear Rims are required.'),
  vehicleCheckInRearTiresPressure: yup
    .number()
    .min(0.0, 'Rear Tire Pressure cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Rear Tire Pressure cannot be more than 999,999,999,999,999.99.')
    .nullable()
    .required('Rear Tire Pressure is required.'),
  vehicleCheckInNumberOfRearTires: yup
    .number()
    .min(0.0, 'Number of Rear Tires cannot be less than 0.00.')
    .max(999_999_999, 'Number of Rear Tires cannot be more than 999,999,999.')
    .nullable()
    .required('Number of Rear Tires is required.'),
  importerNotes: yup.string().max(200, 'Importer Notes cannot be more than 200 characters').nullable()
})
